<template>
  <div v-if="brains" class="general_container">
    <div class="general_block-wrapper header">
      <h2 class="general_title">General</h2>
      <p class="general_description">
        Change the general settings of your chatbot
      </p>
    </div>
    <div class="general_block-wrapper">
      <p class="general_block-title">Description:</p>

      <textarea
        class="textarea"
        name="description" 
        id=""
        @input="handleChange"
      >{{ brains?.general?.description }}</textarea>

      <p class="general_description">
        This description will be shown in the main home screen of your chatbot.
      </p>
    </div>
    <div class="general_block-wrapper">
      <p class="general_block-title">System Prompt:</p>

      <textarea
        class="textarea"
        name="systemPrompt"
        id=""
        placeholder="You are a funny Ai bot assistant, include joke in your answers"
        @input="handleChange"
      >{{ brains?.general?.systemPrompt }}</textarea>

      <p class="general_description">
        Use this to change the instructions you give to your chatbot in the user
        prompt
      </p>
    </div>
    <div class="general_block-wrapper">
      <p class="general_block-title">
        Number of History Characters To Be Considered:
      </p>
      <ul class="general-radio-list">
        <li v-for="item of messagesConsideredArray" class="general-radio-list__item">
          <CustomRadio
            name="messagesConsidered"
            :handleChange="handleChange"
            :checked="item == brains.general.messagesConsidered"
            :value="item" />
        </li>
      </ul>
    </div>
    <div class="general_block-wrapper">
      <p class="general_block-title">GPT Model:</p>
      <FormSelect
        :items="gptModels"
        name="gptModel"
        :userSelect="brains?.general?.gptModel"
        :handleSelect="handleChange"
        type="array"
      />
    </div>
  </div>
</template>

<script>
import FormSelect from "../../components/shared/FormSelect.vue";
import CustomRadio from "../../components/shared/UI/CustomRadio.vue";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";

export default {
  components: {
    FormSelect,
    CustomRadio,
    ButtonWithLoadWebsite
  },
  props: {
    brains: {
      general: {
        description: String,
        systemPrompt: String,
        messagesConsidered: Number,
        gptModel: String
      }
    },
    getChanges: Function
  },
  data() {
    return {
      messagesConsideredArray: [1000, 5000, 10000, 15000],
      gptModels: ['gpt-3.5-turbo'],
    };
  },
  methods: {
    handleChange(e) {
      const {name, value} = e.target;
      
      this.getChanges('general', {...this.brains.general, [name]: value})
    },
  },
};
</script>

<style scoped lang="scss">
.general_container {
  
}

.general_title {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.general_description {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.general_block-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  &.header {
    gap: 8px;
  }
}

.general_block-title {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.textarea {
  height: 84px;
  border-radius: 6px;
  border: 1px solid #d1d1d6;
  padding: 12px 20px;
  outline: none;
  resize: none;
  transition: all 150ms linear;

    &:focus-visible,
    &:hover {
        border-color: rgb(49, 130, 206);
        box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
    }

    @media (min-width: 768px) {
      width: 60%;
    }

    @media (min-width: 1480px) {
      width: 50%;
    }
}

.general-radio-list {
  display: grid;
  gap: 8px;
  width: fit-content;
  grid-template-columns: repeat(3, 1fr);

  @media (min-width: 400px) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
